module.exports = function() {
  return new Worker(__webpack_public_path__ + "web-worker.fa250ec2560b3d762300.js");
};